export enum PinMessageParts {
  None,
  PinEditable,
  PinNoEditable,
}

export enum PinPartActions {
  CopyPart,
  PinPart,
  UnpinPart,
}

type PinPartsNoEditable = {
  type: PinMessageParts.PinNoEditable
}

type PinPartsEditable = {
  type: PinMessageParts.PinEditable,
  callback: (arg: PinPartActions) => void
  piningState: boolean
}

export type PiningPartsHelper = PinPartsEditable | PinPartsNoEditable
